import styled from 'styled-components';

import { theme } from '../../../global';
import { ModalContainer, ModalTitle } from '../Modal/styles';

export interface IFlyoutContainerStylesProps {
  $isActive?: boolean;
}

export const FlyoutCloser = styled(ModalContainer)`
  display: block;
`;

export const StyledFlyout = styled.div<IFlyoutContainerStylesProps>`
  position: fixed;
  right: ${({ $isActive }) => ($isActive ? 0 : '-100%')};
  top: 0;
  width: 545px;
  height: 100vh;
  padding: 20px;
  overflow-y: scroll;
  box-shadow: 0 4px 11px ${theme.colors.shadow_secondary};
  background-color: ${theme.colors.white};
  transition: right 0.2s ease-out;

  /*Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  @media (max-width: 1024px) {
    width: 100vw;
  }
`;

export const FlyoutTitleWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 43px;
`;

export const FlyoutCrossWrapper = styled.div`
  position: absolute;
  left: 20px;
  cursor: pointer;
`;

export const FlyoutTitle = styled(ModalTitle)`
  padding: unset;
`;
